/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProblemDetails } from '../model/problemDetails';
import { ServiceSubscriber } from '../model/serviceSubscriber';
import { ServiceSubscriberDto } from '../model/serviceSubscriberDto';
import { SubscriptionSearchDto } from '../model/subscriptionSearchDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServiceSubscribersService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param phoneNumber 
     * @param serviceId 
     * @param serviceSubscriptionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceSubscribersCheckIfSubscriptionRenewedGet(phoneNumber?: string, serviceId?: string, serviceSubscriptionId?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceSubscriber>;
    public apiServiceSubscribersCheckIfSubscriptionRenewedGet(phoneNumber?: string, serviceId?: string, serviceSubscriptionId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSubscriber>>;
    public apiServiceSubscribersCheckIfSubscriptionRenewedGet(phoneNumber?: string, serviceId?: string, serviceSubscriptionId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSubscriber>>;
    public apiServiceSubscribersCheckIfSubscriptionRenewedGet(phoneNumber?: string, serviceId?: string, serviceSubscriptionId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('serviceId', <any>serviceId);
        }
        if (serviceSubscriptionId !== undefined && serviceSubscriptionId !== null) {
            queryParameters = queryParameters.set('serviceSubscriptionId', <any>serviceSubscriptionId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceSubscriber>('get',`${this.basePath}/api/ServiceSubscribers/CheckIfSubscriptionRenewed`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceSubscribersDeleteServiceSubscriberDelete(id?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiServiceSubscribersDeleteServiceSubscriberDelete(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiServiceSubscribersDeleteServiceSubscriberDelete(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiServiceSubscribersDeleteServiceSubscriberDelete(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/ServiceSubscribers/DeleteServiceSubscriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param phoneNumber 
     * @param serviceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceSubscribersGetServiceSubscriberByPhoneNumberAndServiceIdGet(phoneNumber?: string, serviceId?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceSubscriberDto>;
    public apiServiceSubscribersGetServiceSubscriberByPhoneNumberAndServiceIdGet(phoneNumber?: string, serviceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSubscriberDto>>;
    public apiServiceSubscribersGetServiceSubscriberByPhoneNumberAndServiceIdGet(phoneNumber?: string, serviceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSubscriberDto>>;
    public apiServiceSubscribersGetServiceSubscriberByPhoneNumberAndServiceIdGet(phoneNumber?: string, serviceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('serviceId', <any>serviceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceSubscriberDto>('get',`${this.basePath}/api/ServiceSubscribers/GetServiceSubscriberByPhoneNumberAndServiceId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param phoneNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceSubscribersGetServiceSubscriberByPhoneNumberGet(phoneNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceSubscriberDto>>;
    public apiServiceSubscribersGetServiceSubscriberByPhoneNumberGet(phoneNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceSubscriberDto>>>;
    public apiServiceSubscribersGetServiceSubscriberByPhoneNumberGet(phoneNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceSubscriberDto>>>;
    public apiServiceSubscribersGetServiceSubscriberByPhoneNumberGet(phoneNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceSubscriberDto>>('get',`${this.basePath}/api/ServiceSubscribers/GetServiceSubscriberByPhoneNumber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceSubscribersGetServiceSubscriberByServiceCodeGet(serviceCode?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceSubscriber>>;
    public apiServiceSubscribersGetServiceSubscriberByServiceCodeGet(serviceCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceSubscriber>>>;
    public apiServiceSubscribersGetServiceSubscriberByServiceCodeGet(serviceCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceSubscriber>>>;
    public apiServiceSubscribersGetServiceSubscriberByServiceCodeGet(serviceCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceCode !== undefined && serviceCode !== null) {
            queryParameters = queryParameters.set('serviceCode', <any>serviceCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceSubscriber>>('get',`${this.basePath}/api/ServiceSubscribers/GetServiceSubscriberByServiceCode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceSubscribersGetServiceSubscriptionHistoryPost(body?: SubscriptionSearchDto, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceSubscriberDto>>;
    public apiServiceSubscribersGetServiceSubscriptionHistoryPost(body?: SubscriptionSearchDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceSubscriberDto>>>;
    public apiServiceSubscribersGetServiceSubscriptionHistoryPost(body?: SubscriptionSearchDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceSubscriberDto>>>;
    public apiServiceSubscribersGetServiceSubscriptionHistoryPost(body?: SubscriptionSearchDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ServiceSubscriberDto>>('post',`${this.basePath}/api/ServiceSubscribers/GetServiceSubscriptionHistory`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceSubscribersInsertRangeOfServiceSubscribersPost(body?: Array<ServiceSubscriber>, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceSubscriber>>;
    public apiServiceSubscribersInsertRangeOfServiceSubscribersPost(body?: Array<ServiceSubscriber>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceSubscriber>>>;
    public apiServiceSubscribersInsertRangeOfServiceSubscribersPost(body?: Array<ServiceSubscriber>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceSubscriber>>>;
    public apiServiceSubscribersInsertRangeOfServiceSubscribersPost(body?: Array<ServiceSubscriber>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ServiceSubscriber>>('post',`${this.basePath}/api/ServiceSubscribers/InsertRangeOfServiceSubscribers`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceSubscribersInsertServiceSubscriberPost(body?: ServiceSubscriber, observe?: 'body', reportProgress?: boolean): Observable<ServiceSubscriber>;
    public apiServiceSubscribersInsertServiceSubscriberPost(body?: ServiceSubscriber, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSubscriber>>;
    public apiServiceSubscribersInsertServiceSubscriberPost(body?: ServiceSubscriber, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSubscriber>>;
    public apiServiceSubscribersInsertServiceSubscriberPost(body?: ServiceSubscriber, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ServiceSubscriber>('post',`${this.basePath}/api/ServiceSubscribers/InsertServiceSubscriber`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceSubscribersRenewSubscriptionPost(body?: ServiceSubscriberDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiServiceSubscribersRenewSubscriptionPost(body?: ServiceSubscriberDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiServiceSubscribersRenewSubscriptionPost(body?: ServiceSubscriberDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiServiceSubscribersRenewSubscriptionPost(body?: ServiceSubscriberDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/ServiceSubscribers/RenewSubscription`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceSubscribersUpdateServiceSubscriberPut(body?: ServiceSubscriber, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiServiceSubscribersUpdateServiceSubscriberPut(body?: ServiceSubscriber, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiServiceSubscribersUpdateServiceSubscriberPut(body?: ServiceSubscriber, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiServiceSubscribersUpdateServiceSubscriberPut(body?: ServiceSubscriber, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/ServiceSubscribers/UpdateServiceSubscriber`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
